// Swap the product gallery's first image when a subscription plan is selected
// (via Appstle or any selling-plan picker). Reads the swap URL from
// `data-subscription-image` on the product main element (set in
// sections/main-product.liquid from product.metafields.custom.subscription_image).
// Restores the original image when the buyer flips back to a one-time purchase.
//
// Set `window.__subscriptionImageDebug = true` (in console) to enable logging.

(function () {
  function log() {
    if (window.__subscriptionImageDebug) {
      var args = Array.prototype.slice.call(arguments);
      console.log.apply(console, ['[sub-image]'].concat(args));
    }
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else { fn(); }
  }

  ready(function () {
    var host = document.querySelector('[data-subscription-image]');
    if (!host) { log('no host element with data-subscription-image'); return; }
    var subUrl = host.getAttribute('data-subscription-image');
    if (!subUrl) { log('data-subscription-image is empty'); return; }
    log('host found, subUrl =', subUrl);

    var firstImg =
      host.querySelector('.product__media-item img') ||
      host.querySelector('media-gallery img') ||
      host.querySelector('.product__media-wrapper img');
    if (!firstImg) { log('no first image found'); return; }
    log('first image =', firstImg);

    var origSrc = firstImg.getAttribute('src');
    var origSrcset = firstImg.getAttribute('srcset');
    var origDataSrc = firstImg.getAttribute('data-src');
    var lastState = null;

    function withWidth(url, w) {
      if (!url) return '';
      var clean = url.replace(/[?&]width=\d+/g, '').replace(/[?&]$/, '');
      var sep = clean.indexOf('?') === -1 ? '?' : '&';
      return clean + sep + 'width=' + w;
    }

    // Detection: find the EFFECTIVE selling_plan value on the page.
    //   - Hidden/text inputs: use .value directly.
    //   - Radio/checkbox inputs: only count when .checked. (Appstle has two
    //     radios named "selling_plan" — one for one-time (value="") and one
    //     for the subscription plan id. Reading both would always look subbed.)
    function currentlySubscription() {
      var spInputs = document.querySelectorAll('input[name="selling_plan"]');
      for (var i = 0; i < spInputs.length; i++) {
        var input = spInputs[i];
        if (input.type === 'radio' || input.type === 'checkbox') {
          if (!input.checked) continue;
        }
        var v = String(input.value || '').trim();
        if (v && v !== '0') return true;
      }
      // Body-class hint that some apps add.
      if (document.body.classList.contains('appstle-subscription-selected')) return true;
      return false;
    }

    function applyState(isSub) {
      if (isSub === lastState) return;
      lastState = isSub;
      log('apply state', isSub ? 'subscription' : 'onetime');
      if (isSub) {
        firstImg.setAttribute('src', subUrl);
        firstImg.setAttribute('srcset',
          withWidth(subUrl, 400) + ' 400w, ' +
          withWidth(subUrl, 800) + ' 800w, ' +
          withWidth(subUrl, 1200) + ' 1200w, ' +
          withWidth(subUrl, 1600) + ' 1600w');
        if (origDataSrc != null) firstImg.setAttribute('data-src', subUrl);
      } else {
        if (origSrc != null) firstImg.setAttribute('src', origSrc); else firstImg.removeAttribute('src');
        if (origSrcset != null) firstImg.setAttribute('srcset', origSrcset); else firstImg.removeAttribute('srcset');
        if (origDataSrc != null) firstImg.setAttribute('data-src', origDataSrc);
      }
    }

    function refresh() { applyState(currentlySubscription()); }

    document.addEventListener('change', refresh, true);
    document.addEventListener('click', function () { setTimeout(refresh, 30); }, true);
    // Poll as fallback for widgets that set input.value without firing events.
    setInterval(function () { if (!document.hidden) refresh(); }, 400);

    refresh();
    log('initialized');
  });
})();
